import { gql } from '@apollo/client';

export const LOGOUT = gql(/*GraphQL*/ `
mutation Logout {
  logout

}`);
